import React from "react";

import { Banner as DSBanner } from "@packages/ds";

import type { BannerProps, BannerPriority } from "@packages/ds";

// Re-export the BannerPriority enum type for backward compatibility
export type { BannerPriority as Priority };

// Renaming the type to Props for backward compatibility
export type Props = BannerProps;

/**
 * Banner component for displaying important messages
 */
const Banner = (props: Props) => {
  return <DSBanner {...props} />;
};

export default Banner;
